import { CompanyIcon } from '@/components/CompanyIcon';
import type { Brokerage } from '../../hooks/useBrokerSearch';
import { getSanitisedUrl } from '../../utils';

type BrokerProps = Pick<Brokerage, 'name' | 'url'> & {
  onClick: () => void;
};

export const BrokerageItem = ({ name, url, onClick }: BrokerProps) => {
  const website = getSanitisedUrl(url);
  return (
    <article>
      <button
        type="button"
        className="group/brokerage border relative w-full overflow-hidden rounded-lg border-subtle p-x1 text-left focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent focus-visible:duration-0"
        onClick={onClick}
      >
        {/* Background */}
        <div className="pointer-events-none absolute inset-0 bg-p-white opacity-[2.5%] transition-opacity group-hover/brokerage:opacity-[4.5%] group-active/brokerage:opacity-[2.5%] light:bg-p-black light:opacity-[5%]" />
        <div className="relative grid grid-cols-[40px,minmax(0,1fr)] items-center gap-x1">
          <CompanyIcon
            tickerSymbol={name.substring(0, 3).toUpperCase()}
            website={website}
            size={40}
          />
          <div>
            <div className="truncate text-xs text-solid">{name}</div>
            {website !== 'No URL' && (
              <div className="truncate text-tiny text-softer">{website}</div>
            )}
          </div>
        </div>
      </button>
    </article>
  );
};

export const BrokerageItemSkeleton = () => (
  <div className="border relative box-content h-[40px] overflow-hidden rounded-lg border-subtle p-x1">
    <div className="pointer-events-none absolute inset-0 bg-p-white opacity-[2.5%] transition-opacity light:bg-p-black light:opacity-[5%]" />
  </div>
);
